import {computed} from "vue";
import {useAppInfo} from "@/composables/useAppInfo";

export function useAppVersion() {
    const info = useAppInfo();
    return computed(() => {
        if (import.meta.env.DEV) {
            return `${info.value?.version}-dev+${info.value?.build}`;
        }
        if (import.meta.env.MODE === 'staging') {
            return `${info.value?.version}-beta+${info.value?.build}`;
        }
        return `${info.value?.version}+${info.value?.build}`;
    });
}